// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/active-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/inactive-flag.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.searchHistoryTable {
    padding: 1rem;
    min-height: 300px !important;
    background-color: #f0f0f0;
}

.searchHistoryTable {
    padding: 1rem;
    min-height: 300px !important;
}

.searchHistoryTable .active-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    margin-left: 2.03rem;
}

.searchHistoryTable .inactive-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    margin-left: 2.03rem;
}

.historyTable tbody, .historyTable tr {
    display: block;
}

.historyTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.historyTable tbody {
    /* height: 74vh; */
    overflow-y: scroll;
    min-height: auto;
    max-height: 74vh;

}

.historyTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.historyTable tbody>tr>td {
    width: 7rem;
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
}

.historyTable thead>tr>th {
    width: 7rem;
    float: left;
}
div.historyTable div.row.react-bootstrap-table-pagination div {
    padding: 0px !important;
}

.downloadTable tbody, .downloadTable tr {
    display: block;
}

.downloadTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.downloadTable tbody {
    min-height: auto;
    /* height: 73vh; */
    overflow-y: scroll;
    max-height: 74vh;

}

.downloadTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.downloadTable tbody>tr>td {
    width: 7rem;
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
}

.downloadTable thead>tr>th {
    width: 7rem;
    float: left;
}
div.downloadTable div.row.react-bootstrap-table-pagination div {
    padding: 0px !important;
}


.downloadTreeContainer{
    background-color:white;
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;  
    padding: 5px;  
}
    

.paddingTab {
        padding-top: 3rem;
    }

.uploadContainer .nav-link{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    
.uploadContainer.tab-content{
        min-height: 779px;
}

        .nav-link {
            background-color: #FFFFFF;
            margin-right: 2px !important;
          }
          
          .nav-tabs {
            border-bottom: 0px !important;
          }
          
          .nav-tabs .nav-item {
            width: 24%;
            text-align: center;
            font-size: 0.81rem;
          }
          
          .nav-tabs>li:first-child>a {
            border-top-left-radius: 1.25rem;
          }
          
          .nav-tabs>li:last-child>a {
            border-top-right-radius: 1.25rem;
          }
          
          .nav-link.active {
            font-weight: bold !important;
            border-bottom-width: 0.2rem !important;
            /* border-width: 1px; */
            /* border-style: solid; */
            border-color: transparent transparent rgb(229, 0, 0);
            /* border-image: initial; */
        } 
        .treeBeard ul {
            background: white !important;
            color: black;
        
        }
        .treeBeard li{
            background: white !important;
            padding-top: 5px;
        }
        
        .treeBeard li>div {
            background: white !important;
            color:black !important;
        }
        
        .treeBeard .activeQuestion{
            color:black !important;
        }
                        
        .launch-icon {
            /* background-image: url("../../assets/images/launch.png"); */
            height: 19px;
            width: 30px;
            background-position: center;
            background-repeat: no-repeat;
            margin: 0 0.3rem;
            float: right;
        }


        
.targetSetting tbody, .targetSetting tr {
    display: block;
}

.targetSetting tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.targetSetting tbody {
    overflow-y: scroll;
    min-height: auto;
    max-height: 31vh;

}

/* .targetSetting .react-bootstrap-table {
    overflow-y: scroll;
    min-height: auto;
    max-height: 43vh;
} */

.targetSetting table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.targetSetting tbody>tr>td {
    width: 17%;
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
}

.targetSetting thead>tr>th {
    /* width: 7rem; */
    float: left;
}
div.targetSetting div.row.react-bootstrap-table-pagination div {
    padding: 0px !important;
}

.targetSetting tbody tr td {
    /* padding-left: 35px; */
}

.targetSetting .form-control {
  width: 90%;
  height: calc(2.25rem + 2px);
}


.dsabledSelectKpiEntry{
    width: 11.4rem !important;
}

.activitysStatus .css-10nd86i .css-1hwfws3 .css-1492t68 {
    text-indent: -9999px;
}

.activitysStatus .css-10nd86i{
    max-width: 200px  !important;
}

.activitysStatus .css-10nd86i .css-15brt4p{
    min-width: 184px !important;
}

.activitysStatus .css-10nd86i .css-1kuo3lu{
    min-width: 184px !important;
}

.activitysStatus .css-11unzgr{
    overflow: visible  !important;
}

.activitysStatus .css-11unzgr .css-lc91z5{
    min-width: 200px  !important;
}

.evaluationYear{
    width: 10.7rem !important;
}

.kpiEntryAccordian .card-header{
    padding: 8px !important;
}

.kpiEntryAccordian .cardPadding{
    padding: 0.25rem !important;
}

.kpiEntryCard{
    margin-bottom: 4px;
    box-shadow: none !important;
}

.kpiEntryAccordian .react-bootstrap-table th[data-row-selection] {
    width: 42px;
}

.kpiEntryAccordian .react-bootstrap-table {
    /* overflow-x: auto !important; */
    /* overflow-y: scroll; */
    /* min-height: auto;
    max-height: 44vh; */
}
.kpiEntryAccordian .react-bootstrap-table {
    overflow-x: auto !important;
}
.trClass {
    border-bottom: 0px solid #f0f0f0!important;
}

.kpiEntryAccordian table.table th, table.table td{
    padding-top: 0.3rem !important;
    padding-bottom: 0.5rem !important;
    vertical-align : baseline;
    vertical-align : initial;
    /* border-bottom: 1px solid #dee2e6 !important; */
}

.table {
    margin-bottom : 0rem !important;
}

.kpiEntryAccordian tbody>tr {
    border-bottom: 2px solid #f0f0f0!important;
}

.childParamTable tbody>tr {
    border-bottom: 1px solid #f0f0f0!important;
}
.childParamTable thead>tr {
    border-bottom: 1px solid #f0f0f0!important;
    width: max-content;
}
.kpiEntryAccordian .react-bootstrap-table table {
     table-layout: fixed;
    /* width: 190% !important;  */
}

.childParamTable .react-bootstrap-table table {
    /* table-layout: auto;
    width: 125% !important; */
    /* table-layout: fixed;
    width: 70% !important; */
    margin-left: 15px;
} 
.childParamTable .react-bootstrap-table {
    overflow-x: visible !important;
    /* overflow-x: initial !important; */
}


.activeFieldKpiEntry-toyota .css-1wy0on6 svg{
    color: #e50000 ;
}

.activeFieldKpiEntry-lexus .css-1wy0on6 svg{
    color: #252525 ;
}

.activeFieldKpiEntry{
    width : 11.4rem !important
}


.disabledFieldKpiEntry .css-1wy0on6 div svg{
    color: rgb(204,204,204);
}

.disabledFieldKpiEntry{
    width : 11.4rem !important
}

.dsabledSelectActivityStatus{
    width: 8.4rem !important;
}

.kpiEntryAccordian .expanding-row {
    display: flex;
}

.parentParamTable tbody, .parentParamTable tr {
    display: block;
}

.parentParamTable tbody {
    overflow-y: auto;
    height: 13rem;
}

.childParamTable tbody {
    width: max-content;
    height: auto;
}

.boldFont {
    font-weight: bold;
    padding-top: 1.0rem;
}

.pointAllocate {
   width: 75%
}

.pointAllocate tbody {
    overflow-y: scroll;
    min-height: auto;
    max-height: 52.2vh;
}

.pointAllocate .form-control {
    width: 60%;
    margin-left: 55px;
}

.pointAllocate tbody>tr>td {
    width: 24%;
}

.warningWidth .modal-content {
    max-width: 530px !important;
    margin: 0px 365px 100px;
}
`, "",{"version":3,"sources":["webpack://./src/components/annualSetup/index.css"],"names":[],"mappings":";;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yDAA8D;IAC9D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,sBAAsB;IACtB,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,YAAY;AAChB;;;AAGA;QACQ,iBAAiB;IACrB;;AAEJ;QACQ,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;MACrB;;AAEN;QACQ,iBAAiB;AACzB;;QAEQ;YACI,yBAAyB;YACzB,4BAA4B;UAC9B;;UAEA;YACE,6BAA6B;UAC/B;;UAEA;YACE,UAAU;YACV,kBAAkB;YAClB,kBAAkB;UACpB;;UAEA;YACE,+BAA+B;UACjC;;UAEA;YACE,gCAAgC;UAClC;;UAEA;YACE,4BAA4B;YAC5B,sCAAsC;YACtC,uBAAuB;YACvB,yBAAyB;YACzB,oDAAoD;YACpD,2BAA2B;QAC/B;QACA;YACI,4BAA4B;YAC5B,YAAY;;QAEhB;QACA;YACI,4BAA4B;YAC5B,gBAAgB;QACpB;;QAEA;YACI,4BAA4B;YAC5B,sBAAsB;QAC1B;;QAEA;YACI,sBAAsB;QAC1B;;QAEA;YACI,6DAA6D;YAC7D,YAAY;YACZ,WAAW;YACX,2BAA2B;YAC3B,4BAA4B;YAC5B,gBAAgB;YAChB,YAAY;QAChB;;;;AAIR;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;;;;GAIG;;AAEH;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB;uBACmB;AACvB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;IACjC,yBAAsB;IAAtB,wBAAsB;IACtB,iDAAiD;AACrD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;AACA;IACI,0CAA0C;IAC1C,kBAAkB;AACtB;AACA;KACK,mBAAmB;IACpB,6BAA6B;AACjC;;AAEA;IACI;6BACyB;IACzB;4BACwB;IACxB,iBAAiB;AACrB;AACA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;AACJ;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;GACG;AACH;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B","sourcesContent":["\n\n.searchHistoryTable {\n    padding: 1rem;\n    min-height: 300px !important;\n    background-color: #f0f0f0;\n}\n\n.searchHistoryTable {\n    padding: 1rem;\n    min-height: 300px !important;\n}\n\n.searchHistoryTable .active-flag {\n    background-image: url(\"../../assets/images/active-flag.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    margin-left: 2.03rem;\n}\n\n.searchHistoryTable .inactive-flag {\n    background-image: url(\"../../assets/images/inactive-flag.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    margin-left: 2.03rem;\n}\n\n.historyTable tbody, .historyTable tr {\n    display: block;\n}\n\n.historyTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.historyTable tbody {\n    /* height: 74vh; */\n    overflow-y: scroll;\n    min-height: auto;\n    max-height: 74vh;\n\n}\n\n.historyTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.historyTable tbody>tr>td {\n    width: 7rem;\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.historyTable thead>tr>th {\n    width: 7rem;\n    float: left;\n}\ndiv.historyTable div.row.react-bootstrap-table-pagination div {\n    padding: 0px !important;\n}\n\n.downloadTable tbody, .downloadTable tr {\n    display: block;\n}\n\n.downloadTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.downloadTable tbody {\n    min-height: auto;\n    /* height: 73vh; */\n    overflow-y: scroll;\n    max-height: 74vh;\n\n}\n\n.downloadTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.downloadTable tbody>tr>td {\n    width: 7rem;\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.downloadTable thead>tr>th {\n    width: 7rem;\n    float: left;\n}\ndiv.downloadTable div.row.react-bootstrap-table-pagination div {\n    padding: 0px !important;\n}\n\n\n.downloadTreeContainer{\n    background-color:white;\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;  \n    padding: 5px;  \n}\n    \n\n.paddingTab {\n        padding-top: 3rem;\n    }\n\n.uploadContainer .nav-link{\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n      }\n    \n.uploadContainer.tab-content{\n        min-height: 779px;\n}\n\n        .nav-link {\n            background-color: #FFFFFF;\n            margin-right: 2px !important;\n          }\n          \n          .nav-tabs {\n            border-bottom: 0px !important;\n          }\n          \n          .nav-tabs .nav-item {\n            width: 24%;\n            text-align: center;\n            font-size: 0.81rem;\n          }\n          \n          .nav-tabs>li:first-child>a {\n            border-top-left-radius: 1.25rem;\n          }\n          \n          .nav-tabs>li:last-child>a {\n            border-top-right-radius: 1.25rem;\n          }\n          \n          .nav-link.active {\n            font-weight: bold !important;\n            border-bottom-width: 0.2rem !important;\n            /* border-width: 1px; */\n            /* border-style: solid; */\n            border-color: transparent transparent rgb(229, 0, 0);\n            /* border-image: initial; */\n        } \n        .treeBeard ul {\n            background: white !important;\n            color: black;\n        \n        }\n        .treeBeard li{\n            background: white !important;\n            padding-top: 5px;\n        }\n        \n        .treeBeard li>div {\n            background: white !important;\n            color:black !important;\n        }\n        \n        .treeBeard .activeQuestion{\n            color:black !important;\n        }\n                        \n        .launch-icon {\n            /* background-image: url(\"../../assets/images/launch.png\"); */\n            height: 19px;\n            width: 30px;\n            background-position: center;\n            background-repeat: no-repeat;\n            margin: 0 0.3rem;\n            float: right;\n        }\n\n\n        \n.targetSetting tbody, .targetSetting tr {\n    display: block;\n}\n\n.targetSetting tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.targetSetting tbody {\n    overflow-y: scroll;\n    min-height: auto;\n    max-height: 31vh;\n\n}\n\n/* .targetSetting .react-bootstrap-table {\n    overflow-y: scroll;\n    min-height: auto;\n    max-height: 43vh;\n} */\n\n.targetSetting table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.targetSetting tbody>tr>td {\n    width: 17%;\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.targetSetting thead>tr>th {\n    /* width: 7rem; */\n    float: left;\n}\ndiv.targetSetting div.row.react-bootstrap-table-pagination div {\n    padding: 0px !important;\n}\n\n.targetSetting tbody tr td {\n    /* padding-left: 35px; */\n}\n\n.targetSetting .form-control {\n  width: 90%;\n  height: calc(2.25rem + 2px);\n}\n\n\n.dsabledSelectKpiEntry{\n    width: 11.4rem !important;\n}\n\n.activitysStatus .css-10nd86i .css-1hwfws3 .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.activitysStatus .css-10nd86i{\n    max-width: 200px  !important;\n}\n\n.activitysStatus .css-10nd86i .css-15brt4p{\n    min-width: 184px !important;\n}\n\n.activitysStatus .css-10nd86i .css-1kuo3lu{\n    min-width: 184px !important;\n}\n\n.activitysStatus .css-11unzgr{\n    overflow: visible  !important;\n}\n\n.activitysStatus .css-11unzgr .css-lc91z5{\n    min-width: 200px  !important;\n}\n\n.evaluationYear{\n    width: 10.7rem !important;\n}\n\n.kpiEntryAccordian .card-header{\n    padding: 8px !important;\n}\n\n.kpiEntryAccordian .cardPadding{\n    padding: 0.25rem !important;\n}\n\n.kpiEntryCard{\n    margin-bottom: 4px;\n    box-shadow: none !important;\n}\n\n.kpiEntryAccordian .react-bootstrap-table th[data-row-selection] {\n    width: 42px;\n}\n\n.kpiEntryAccordian .react-bootstrap-table {\n    /* overflow-x: auto !important; */\n    /* overflow-y: scroll; */\n    /* min-height: auto;\n    max-height: 44vh; */\n}\n.kpiEntryAccordian .react-bootstrap-table {\n    overflow-x: auto !important;\n}\n.trClass {\n    border-bottom: 0px solid #f0f0f0!important;\n}\n\n.kpiEntryAccordian table.table th, table.table td{\n    padding-top: 0.3rem !important;\n    padding-bottom: 0.5rem !important;\n    vertical-align : unset;\n    /* border-bottom: 1px solid #dee2e6 !important; */\n}\n\n.table {\n    margin-bottom : 0rem !important;\n}\n\n.kpiEntryAccordian tbody>tr {\n    border-bottom: 2px solid #f0f0f0!important;\n}\n\n.childParamTable tbody>tr {\n    border-bottom: 1px solid #f0f0f0!important;\n}\n.childParamTable thead>tr {\n    border-bottom: 1px solid #f0f0f0!important;\n    width: max-content;\n}\n.kpiEntryAccordian .react-bootstrap-table table {\n     table-layout: fixed;\n    /* width: 190% !important;  */\n}\n\n.childParamTable .react-bootstrap-table table {\n    /* table-layout: auto;\n    width: 125% !important; */\n    /* table-layout: fixed;\n    width: 70% !important; */\n    margin-left: 15px;\n} \n.childParamTable .react-bootstrap-table {\n    overflow-x: visible !important;\n    /* overflow-x: initial !important; */\n}\n\n\n.activeFieldKpiEntry-toyota .css-1wy0on6 svg{\n    color: #e50000 ;\n}\n\n.activeFieldKpiEntry-lexus .css-1wy0on6 svg{\n    color: #252525 ;\n}\n\n.activeFieldKpiEntry{\n    width : 11.4rem !important\n}\n\n\n.disabledFieldKpiEntry .css-1wy0on6 div svg{\n    color: rgb(204,204,204);\n}\n\n.disabledFieldKpiEntry{\n    width : 11.4rem !important\n}\n\n.dsabledSelectActivityStatus{\n    width: 8.4rem !important;\n}\n\n.kpiEntryAccordian .expanding-row {\n    display: flex;\n}\n\n.parentParamTable tbody, .parentParamTable tr {\n    display: block;\n}\n\n.parentParamTable tbody {\n    overflow-y: auto;\n    height: 13rem;\n}\n\n.childParamTable tbody {\n    width: max-content;\n    height: auto;\n}\n\n.boldFont {\n    font-weight: bold;\n    padding-top: 1.0rem;\n}\n\n.pointAllocate {\n   width: 75%\n}\n\n.pointAllocate tbody {\n    overflow-y: scroll;\n    min-height: auto;\n    max-height: 52.2vh;\n}\n\n.pointAllocate .form-control {\n    width: 60%;\n    margin-left: 55px;\n}\n\n.pointAllocate tbody>tr>td {\n    width: 24%;\n}\n\n.warningWidth .modal-content {\n    max-width: 530px !important;\n    margin: 0px 365px 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
